module.exports = __webpack_public_path__ + "static/img/gif55.6a664b91.jpg";